<template>
  <div>
    <!-- 头部 -->
    <div class="row mt-3">
      <div class="col-lg-12"></div>
    </div>
    <header class="header fixed">
      <div class="container">
        <div class="nav-icon">
          <a class="logo" href="/"><i class="icon icon-logo"></i></a>
          <div class="nav-text">{{ infolist.title }}</div>
          <a class="search" :href="infolist.fyurl + '/zb.php'" target="_blank" rel="noopener nofollow"
            ><i class="icon icon-search"></i
          ></a>
        </div>
      </div>
    </header>
    <div class="header-placeholder"></div>

    <!-- 内容 -->
    <div class="container">
      <div class="center-content">
        <!-- 顶部横幅 -->
        <a
          v-for="item in getFilteredApplist(12)"
          :key="item.id"
          :href="item.link"
          target="_blank" 
          rel="noopener nofollow"
        >
          <img :data-src="item.images" class="top_60" />
        </a>
      </div>

      <!-- 公告 -->
      <div class="top-notice">
        <i class="icon icon-notice"></i>
        <div class="marquee-box">
          <span class="marquee"
            >{{ infolist.gonggao }}网页随时会消失，快收录我们的永久页！</span
          >
        </div>
      </div>

      <!-- 轮播图 -->
      <swiper class="pic-slide pic-slide1" :options="swiperOptions1">
        <swiper-slide v-for="item in getFilteredApplist(1)" :key="item.id">
          <a class="swiper-lazy" :href="item.link" :data-bg="item.images">
            <div class="swiper-lazy-preloader"></div>
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <!-- 直播 -->
      <div class="panel panel-app">
        <div class="panel-head">
          <h3>福利直播<small>甜甜的小姐姐等你挑选</small></h3>
          <a class="more" :href="infolist.fyurl + '/bfq.php'" target="_blank" rel="noopener nofollow">绿色安全</a>
        </div>
        <div class="panel-body panel-app-body">
          <ul class="app-list">
            <li
              v-for="item in getFilteredApplist(2)"
              :key="item.id"
              class="app-item app-item2"
            >
              <a :href="item.link" target="_blank" rel="noopener nofollow">
                <div class="app-icon-wrapper">
                  <div class="app-icon" :data-bg="item.images"></div>
                </div>
                <span class="app-item-name">{{ item.title }}</span>
              </a>
            </li>
          </ul>

          <ul class="app-list">
            <li
              v-for="item in getFilteredApplist(3)"
              :key="item.id"
              class="app-item"
            >
              <a :href="item.link" target="_blank" rel="noopener nofollow">
                <div class="app-icon-wrapper">
                  <div class="app-icon" :data-bg="item.images"></div>
                </div>
                <span class="app-item-name">{{ item.title }}</span>
                <span class="btn btn-download">安装</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 免费推荐 -->
      <div class="panel panel-app">
        <div class="panel-head">
          <h3>免费推荐<small>请多选下载几个以防失效</small></h3>
          <a class="more" :href="infolist.fyurl + '/bfq.php'" target="_blank" rel="noopener nofollow">绿色安全</a>
        </div>
        <div class="panel-body panel-app-body">
          <ul class="app-list">
            <li
              v-for="item in getFilteredApplist(11)"
              :key="item.id"
              class="app-item"
            >
              <a :href="item.link" target="_blank" rel="noopener nofollow">
                <div class="app-icon-wrapper">
                  <div class="app-icon" :data-bg="item.images"></div>
                </div>
                <span class="app-item-name">{{ item.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 会员精品 -->
      <div class="panel panel-app">
        <div class="panel-head">
          <h3>会员精品<small>请多选下载几个以防失效</small></h3>
          <a class="more" :href="infolist.fyurl + '/bfq.php'" target="_blank" rel="noopener nofollow">绿色安全</a>
        </div>
        <div class="panel-body panel-app-body">
          <ul class="app-list">
            <li
              v-for="item in getFilteredApplist(4)"
              :key="item.id"
              class="app-item"
            >
              <a :href="item.link" target="_blank" rel="noopener nofollow">
                <div class="app-icon-wrapper">
                  <div class="app-icon" :data-bg="item.images"></div>
                </div>
                <span class="app-item-name">{{ item.title }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 福利推荐 -->
      <div class="panel panel-app">
        <div class="panel-head">
          <h3>福利推荐<small>R星出品，必属精品</small></h3>
          <a class="more" :href="infolist.fyurl + '/bfq.php'" target="_blank" rel="noopener nofollow">绿色安全</a>
        </div>
        <div class="panel panel-app panel-app-slide">
          <swiper class="pic-slide pic-slide2" :options="swiperOptions2">
            <swiper-slide v-for="item in getFilteredApplist(5)" :key="item.id">
              <a class="swiper-lazy" :href="item.link" :data-bg="item.images" target="_blank" rel="noopener nofollow">
                <div class="swiper-lazy-preloader"></div>
              </a>
            </swiper-slide>
          </swiper>
          <div class="panel-body panel-app-body">
            <ul class="app-list">
              <li
                v-for="item in getFilteredApplist(6)"
                :key="item.id"
                class="app-item"
              >
                <a :href="item.link" target="_blank" rel="noopener nofollow">
                  <div class="app-icon-wrapper">
                    <div class="app-icon" :data-bg="item.images"></div>
                  </div>
                  <span class="app-item-name">{{ item.title }}</span>
                  <span class="app-item-desc">{{ item.describe }}</span>
                  <span class="btn btn-download">安装</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 热门信息 -->
      <div class="panel panel-video">
        <div class="panel-head">
          <h3>热门信息</h3>
          <a class="more" :href="infolist.fyurl + '/bfq.php'" target="_blank" rel="noopener nofollow">绿色无毒</a>
        </div>
        <div class="panel-body">
          <swiper class="app-circle-slide" :options="swiperOptions3">
            <swiper-slide v-for="item in getFilteredApplist(7)" :key="item.id">
              <a class="app-circle-item" :href="item.link" target="_blank" rel="noopener nofollow">
                <div class="app-icon swiper-lazy" :data-bg="item.images"></div>
                <span class="app-circle-name">{{ item.title }}</span>
              </a>
              <div class="swiper-lazy-preloader"></div>
            </swiper-slide>
          </swiper>

          <div class="label-container">
            <div class="label-box">
              <div class="label-pic">
                <div
                  class="app-icon"
                  :style="{
                    backgroundImage:
                      'url(https://img.foyeseo.com/i/2023/10/21/swag.png)'
                  }"
                ></div>
              </div>
              <div class="label-info">
                <div class="label-name">
                  <h3>台湾Swag</h3>
                  <span class="label-num">收录视频365部</span>
                </div>
                <div class="label-desc">
                  必淫福利精心整理收集【台湾swag】最新收费视频，持续保持最快速度每日同步更新最新巨作，让您一站式观看各大平台收费内容！
                </div>
              </div>
            </div>
            <ul class="video-list">
              <li
                v-for="item in getFilteredApplist(8)"
                :key="item.id"
                class="video-item"
              >
                <a class="app-circle-item" :href="item.link" target="_blank" rel="noopener nofollow">
                  <div class="video-cover" :data-bg="item.images"></div>
                  <div class="video-name">{{ item.title }}</div>
                  <div class="video-foot">
                    <span class="video-hits">{{ item.dianji }}.2w次播放</span>
                    <span class="video-time">{{ item.beiyong1 }}</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>

          <div class="label-container">
            <div class="label-box">
              <div class="label-pic">
                <div
                  class="app-icon"
                  :style="{
                    backgroundImage:
                      'url(https://img.foyeseo.com/i/2023/10/21/mdcm.jpg)'
                  }"
                ></div>
              </div>
              <div class="label-info">
                <div class="label-name">
                  <h3>麻豆传媒映画</h3>
                  <span class="label-num">收录视频652部</span>
                </div>
                <div class="label-desc">
                  必淫福利精心整理收集【麻豆传媒映画】最新收费视频，持续保持最快速度每日同步更新最新巨作，让您一站式观看各大平台收费内容！
                </div>
              </div>
            </div>
            <ul class="video-list">
              <li
                v-for="item in getFilteredApplist(9)"
                :key="item.id"
                class="video-item"
              >
                <a class="app-circle-item" :href="item.link" target="_blank" rel="noopener nofollow">
                  <div class="video-cover" :data-bg="item.images"></div>
                  <div class="video-name">{{ item.title }}</div>
                  <div class="video-foot">
                    <span class="video-hits">{{ item.dianji }}.2w次播放</span>
                    <span class="video-time">{{ item.beiyong1 }}</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>

          <div class="label-container">
            <div class="label-box">
              <div class="label-pic">
                <div
                  class="app-icon"
                  :style="{
                    backgroundImage:
                      'url(https://img.foyeseo.com/i/2023/10/21/91zpc.jpg)'
                  }"
                ></div>
              </div>
              <div class="label-info">
                <div class="label-name">
                  <h3>91制片厂</h3>
                  <span class="label-num">收录视频242部</span>
                </div>
                <div class="label-desc">
                  必淫福利精心整理收集【91制片厂（前果冻传媒）】最新收费视频，持续保持最快速度每日同步更新最新巨作，让您一站式观看各大平台收费内容！
                </div>
              </div>
            </div>
            <ul class="video-list">
              <li
                v-for="item in getFilteredApplist(10)"
                :key="item.id"
                class="video-item"
              >
                <a class="app-circle-item" :href="item.link" target="_blank" rel="noopener nofollow">
                  <div class="video-cover" :data-bg="item.images"></div>
                  <div class="video-name">{{ item.title }}</div>
                  <div class="video-foot">
                    <span class="video-hits">{{ item.dianji }}.2w次播放</span>
                    <span class="video-time">{{ item.beiyong1 }}</span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="top-notice">
        <i class="icon icon-notice"></i>
        <div class="marquee-box">
          <span class="marquee">{{ infolist.gonggao }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      // 轮播图 1 的配置
      swiperOptions1: {
        autoplay: true, // 自动播放
        loop: true, // 循环播放
        lazy: {
          loadPrevNext: true // 延迟加载
        },
        pagination: {
          el: ".swiper-pagination", // 分页器
          clickable: true // 分页器可点击
        }
      },
      // 轮播图 2 的配置
      swiperOptions2: {
        autoplay: true, // 自动播放
        loop: true, // 循环播放
        lazy: {
          loadPrevNext: true // 延迟加载
        }
      },
      // 圆形轮播图的配置
      swiperOptions3: {
        lazy: {
          loadPrevNext: true // 延迟加载
        },
        speed: 2000, // 切换速度
        autoplay: {
          delay: 0 // 自动播放间隔
        },
        loop: true, // 循环播放
        slidesPerView: 5, // 同时显示的幻灯片数量
        spaceBetween: 10 // 幻灯片之间的间距
      },
      tjqdbm: "",
      applist: [],
      typelist: [],
      infolist: []
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    // 初始化头部边框逻辑
    this.headBorder();
    window.addEventListener("scroll", this.headBorder);
    document.title = this.infolist.title || "R星出品|必属精品";
  },
  watch: {
    "$route.query.channel": "fetchData"
  },
  methods: {
    async fetchData() {
      const urlParams = new URLSearchParams(window.location.search);
      const tjqdbm = urlParams.get("vv") || "";
      console.log("tjqdbm:", tjqdbm);
      try {
        const response = await axios.post(`${this.$apiBaseUrl}/fyapi`, {
          tjqdbm: tjqdbm,
          domain: window.location.hostname
        });
        const data = response.data;
        this.tjqdbm = data.tjqdbm;
        this.applist = data.applist;
        this.typelist = data.typelist;
        this.infolist = data.infolist;
        this.$nextTick(() => {
          this.hideRandomVideoItems();
          this.initLazyLoad();
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    // 获取过滤后的应用列表
    getFilteredApplist(typeids, Hot = false, limit = this.applist.length) {
      if (!Array.isArray(typeids)) {
        typeids = [typeids];
      }
      let filteredList = this.applist.filter((item) =>
        typeids.includes(item.cate_id)
      );
      if (Hot) {
        filteredList = filteredList.filter((item) => item.hot === 1);
      }
      return filteredList.slice(0, limit).sort((a, b) => {
        if (b.sort !== a.sort) {
          return b.sort - a.sort;
        }
        if (b.hot !== a.hot) {
          return b.hot - a.hot;
        }
        return b.dianji - a.dianji;
      });
    },
    // 获取过滤后的分类列表
    getFilteredTypelist(...ids) {
      if (!Array.isArray(ids)) {
        ids = [ids];
      }
      return this.typelist
        .filter((item) => ids.includes(item.id))
        .sort((a, b) => a.sort - b.sort);
    },

    // 头部边框逻辑
    headBorder() {
      if (window.scrollY > 0) {
        document.querySelector(".header").classList.add("border");
      } else {
        document.querySelector(".header").classList.remove("border");
      }
    },

    //随机列表
    hideRandomVideoItems() {
      const videoLists = document.querySelectorAll(".video-list");
      videoLists.forEach((videoList) => {
        const videoItems = Array.from(
          videoList.querySelectorAll(".video-item")
        );
        const randomItems = this.getRandomArrayElements(videoItems, 4);
        randomItems.forEach((item) => (item.style.display = "none"));
      });
    },
    getRandomArrayElements(arr, count) {
      count = arr.length < count ? arr.length : count;
      const shuffled = arr.slice(0);
      let i = arr.length,
        min = i - count,
        temp,
        index;
      while (i-- > min) {
        index = Math.floor((i + 1) * Math.random());
        temp = shuffled[index];
        shuffled[index] = shuffled[i];
        shuffled[i] = temp;
      }
      return shuffled.slice(min);
    },

    // 懒加载图片
    initLazyLoad() {
      if (!('IntersectionObserver' in window)) {
        const lazyElements = document.querySelectorAll("[data-src], [data-bg]");
        lazyElements.forEach((el) => {
          if (el.tagName === "IMG") {
            el.src = el.dataset.src;
          }
          if (el.dataset.bg) {
            el.style.backgroundImage = `url(${el.dataset.bg})`;
          }
        });
        return;
      }
      const lazyElements = document.querySelectorAll("[data-src], [data-bg]");
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const el = entry.target;
              if (el.tagName === "IMG") {
                el.src = el.dataset.src;
              }
              if (el.dataset.bg) {
                el.style.backgroundImage = `url(${el.dataset.bg})`;
              }
              observer.unobserve(el);
            }
          });
        },
        {
          rootMargin: "0px 0px 100px 0px", // 提前 100px 加载
          threshold: 0.1 // 当 10% 的元素进入视口时触发
        }
      );
      lazyElements.forEach((el) => {
        observer.observe(el);
      });
    }

  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.headBorder);
  }
};
</script>

<style scoped>
@import "../../public/rxmb/css/style.css";

.marquee-box {
  overflow: hidden;
  white-space: nowrap;
}

.marquee {
  display: inline-block;
  padding-left: 100%;
  animation: marquee 15s linear infinite;
}

@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.top_60 {
  width: 440px;
  height: 79px;
  margin-bottom: 3px;
}
@media screen and (max-width: 600px) {
  .top_60 {
    width: 100%;
    height: 70px;
    margin-bottom: 4px;
  }
}
</style>
